import loadable from '../../utilities/loadable'

export const PharmacyDashboard = loadable(() => import('./PharmacyDashboard'))
